import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliPages');
export const actions = helper.createActions('portaliPages', actionTypes);
